import React from 'react';
import LinkButton from '../common/LinkButton';
import { MUNDI_LINK, AWS_EU_LINK } from '../../constants/links';
import ClosableWarning from '../common/ClosableWarning';

const MundiWarning = () => {
  return (
    <ClosableWarning>
      <div style={{ fontSize: '0.85rem' }}>
        <b>WARNING: Mundi BYOC layers</b>
        <p>
          Layers that use BYOC with S3 bucket in Mundi are processed on different infrastructure,
          which require:
          <br />
          -The use of <LinkButton>{MUNDI_LINK}</LinkButton> end-point instead of{' '}
          <LinkButton>{AWS_EU_LINK}</LinkButton> for these layers.
          <br />
          -Layers from different sources should not be mixed within the same configuration instance.
        </p>
        <p>
          In the next few weeks we will migrate these two end-points, but until then please take the
          above into consideration.
        </p>
      </div>
    </ClosableWarning>
  );
};

export default React.memo(MundiWarning);
